var _defs, _rect, _path, _path2, _path3, _path4, _rect2, _path5, _rect3, _path6, _rect4, _path7, _rect5, _path8, _polyline, _polygon, _polygon2, _path9, _polyline2, _polyline3, _polygon3, _polygon4, _path10, _polyline4, _path11, _polygon5, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBot01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    "data-name": "\\u5716\\u5C64 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 185 208",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0fd40b;}.cls-2{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40.5,
    y: 21,
    width: 104,
    height: 59
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158,27.51a23.5,23.5,0,0,1,0,47Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.5,28a23,23,0,0,1,0,46V28m-1-1V75a24,24,0,0,0,0-48Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27,74.49a23.5,23.5,0,0,1,0-47Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5,28V74a23,23,0,0,1,0-46m1-1a24,24,0,0,0,0,48V27Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 172.5,
    width: 27,
    height: 16
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5,173v15h-26V173h26m1-1h-28v17h28V172Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 194.5,
    width: 34,
    height: 13
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5,195v12h-33V195h33m1-1h-35v14h35V194Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 172.5,
    width: 27,
    height: 16
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M128.5,173v15h-26V173h26m1-1h-28v17h28V172Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 194.5,
    width: 34,
    height: 13
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M133.5,195v12h-33V195h33m1-1h-35v14h35V194Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "24.5 112 16.5 115 26.5 130 30.5 126 24.5 112"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "13.5 120 8.5 130 20.5 137 22.5 133 13.5 120"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "6.5 134 5.5 145 18.5 144 18.5 141 6.5 134"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5,166.5a6.5,6.5,0,0,1,13-.66l8.83,5.36a16.2,16.2,0,0,0,.7-4.7A16,16,0,1,0,5.29,178.36l4.83-9.11A6.45,6.45,0,0,1,9.5,166.5Z"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "5.5 148 17.5 147 17.5 151 4.5 156"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "160.5 112 168.5 115 158.5 130 154.5 126 160.5 112"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "171.5 120 176.5 130 164.5 137 162.5 133 171.5 120"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "178.5 134 179.5 145 166.5 144 166.5 141 178.5 134"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M175.5,166.5a6.5,6.5,0,0,0-13-.66l-8.83,5.36a16.2,16.2,0,0,1-.7-4.7,16,16,0,1,1,26.71,11.86l-4.83-9.11A6.45,6.45,0,0,0,175.5,166.5Z"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    points: "179.5 148 167.5 147 167.5 151 180.5 156"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5,0V105h120V0Zm29,68a15,15,0,1,1,15-15A15,15,0,0,1,61.5,68Zm62,0a15,15,0,1,1,15-15A15,15,0,0,1,123.5,68Z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "32.46 110 49.41 165 135.59 165 152.54 110 32.46 110"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.38,132.05H45.69v-1h8.54v1h-3.7v10.16H49.38Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.64,138.17c0,2.27-1.29,4.23-3.71,4.23-2.24,0-3.61-1.78-3.61-4.21S54.63,134,57,134C59.2,134,60.64,135.64,60.64,138.17Zm-6.2,0c0,1.85,1,3.28,2.55,3.28s2.53-1.34,2.53-3.27-.9-3.28-2.56-3.28S54.44,136.29,54.44,138.18Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.76,139.86c0,.79,0,2,0,2.35h-1a12.29,12.29,0,0,1,0-1.31,2.43,2.43,0,0,1-2.52,1.5c-1.25,0-2.65-.55-2.65-2.93v-5.31h1.06v5.07c0,1.12.35,2.19,1.83,2.19,1.65,0,2.28-.92,2.28-3.1v-4.16h1.07Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M77.41,139.8a3.14,3.14,0,0,1-3.21,2.6c-2.11,0-3.52-1.54-3.52-4.18,0-2.24,1.23-4.25,3.61-4.25a2.93,2.93,0,0,1,3.12,2.63H76.34a2,2,0,0,0-2.07-1.69c-1.58,0-2.47,1.34-2.47,3.27s.85,3.28,2.41,3.28a2.11,2.11,0,0,0,2.13-1.66Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.27,130.44v5A2.74,2.74,0,0,1,82.86,134c1.21,0,2.72.63,2.72,3.11v5.13H84.51v-4.94c0-1.49-.66-2.33-1.92-2.33-1.53,0-2.32,1-2.32,2.82v4.45H79.19V130.44Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M91.07,134.16h1.45v-2.45H93.6v2.45h1.85v.93H93.6v5c0,.84.19,1.31.94,1.31a3.07,3.07,0,0,0,.78-.09v.87a3.29,3.29,0,0,1-1.1.14c-1.13,0-1.7-.57-1.7-1.88v-5.35H91.07Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M103.63,138.17c0,2.27-1.28,4.23-3.71,4.23-2.24,0-3.61-1.78-3.61-4.21S97.62,134,100,134C102.19,134,103.63,135.64,103.63,138.17Zm-6.2,0c0,1.85,1,3.28,2.55,3.28s2.53-1.34,2.53-3.27-.9-3.28-2.56-3.28S97.43,136.29,97.43,138.18Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M110,140a2,2,0,0,0,2.14,1.55c1.32,0,1.85-.59,1.85-1.42s-.38-1.24-2.06-1.65c-2.18-.53-2.68-1.19-2.68-2.27S110,134,112,134a2.62,2.62,0,0,1,2.92,2.28h-1a1.76,1.76,0,0,0-1.91-1.39c-1.28,0-1.65.62-1.65,1.22s.36,1,1.9,1.38c2.35.56,2.88,1.34,2.88,2.54,0,1.44-1.16,2.4-3,2.4s-3-1-3.19-2.45Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M115.78,134.16h1.45v-2.45h1.07v2.45h1.85v.93H118.3v5c0,.84.19,1.31.94,1.31a3.07,3.07,0,0,0,.78-.09v.87a3.23,3.23,0,0,1-1.09.14c-1.14,0-1.7-.57-1.7-1.88v-5.35h-1.45Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.46,140.58a11.74,11.74,0,0,0,.11,1.63h-1a4.69,4.69,0,0,1-.14-1.15,2.59,2.59,0,0,1-2.57,1.34,2.41,2.41,0,0,1-2.69-2.43c0-1.79,1.39-2.6,3.79-2.6h1.46v-.76c0-.76-.23-1.74-1.92-1.74-1.5,0-1.73.76-1.9,1.41h-1c.1-1,.71-2.32,3-2.31,1.89,0,2.95.78,2.95,2.58Zm-1-2.39H125c-1.7,0-2.7.45-2.7,1.72A1.56,1.56,0,0,0,124,141.5c2.14,0,2.43-1.42,2.43-3Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130,136.35c0-1.25,0-1.86,0-2.19H131c0,.24,0,.81,0,1.73a3,3,0,0,1,2.77-1.92v1.1a2.75,2.75,0,0,0-2.77,3.08v4.06H130Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M134.72,134.16h1.45v-2.45h1.07v2.45h1.86v.93h-1.86v5c0,.84.19,1.31.95,1.31a3,3,0,0,0,.77-.09v.87a3.2,3.2,0,0,1-1.09.14c-1.13,0-1.7-.57-1.7-1.88v-5.35h-1.45Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot01);
export default __webpack_public_path__ + "static/media/bot-01.2b4134a73e6bbb6bb038619733fb8ea7.svg";
export { ForwardRef as ReactComponent };